import React, { Fragment } from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened} from "../AccountActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, FormField, HiddenField} from "../FormField";
import SimpleDropDown from "../../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";
import {AccessRights, PARTS} from "../../../schemas/accessRightsModel";
import VisualizerSettings from "../VisualizerSettings";
import {showFabricatorsPopup} from "../../../actions";
import {store} from "../../../main";
import {isQFOrLocal, IS_LIXIL_SERVERS, IS_QC_SERVERS} from "../../../utilities/backend";
import {AVAILABLE_CURRENCIES} from "../../../constants/dashboard";

class ToolSettings extends VisualizerSettings {

  render() {
    const {AR, formValues, subscriptionsInfo, tool} = this.props;
    const settings = (formValues && formValues.toolSettings && formValues.toolSettings[tool]) || {};
    const {canEditFields} = this.props.accountPageInfo;
    const allSettingsDisabled = (subscriptionsInfo[`${tool}ProgramType`] === "Select") || !canEditFields;
    let version = settings.version || '4';
    const TOOL = tool[0].toUpperCase() + tool.substring(1);
    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS[tool + "_settings"])}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS[tool + "_settings"])}
                     title={`${tool[0].toUpperCase() + tool.substring(1)} Settings`} sectionsOpened={this.props.sectionsOpened}>
        <div className="acc-container">
          {subscriptionsInfo[`${tool}ProgramType`] === "Select" ? (
            <p className="acc-field text-center" style={{marginTop: 0}}>No {TOOL} program type selected</p>
          ) : null}
          <ul className="acc-list">

            {/*BV_Version*/}
            {AR.isSiteAdmin() ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <div className="acc-checkbox">
                    <SimpleDropDown id={`${tool}_Version`} values={['4','5','6']}
                                    activeValue={version.toString()} label={`${TOOL} Version`}
                                    disabled={!canEditFields}
                                    onChange={(value) => store.dispatch(change('newEntity', `toolSettings[${tool}].version`, value))}/>
                  </div>
                </div>
              </li>
            ) : null}
            {/*BV_Version end*/}

            {/*Currency*/}
            <li className="acc-container__row">
              <div className="acc-block">
                <div className="acc-checkbox">
                  <SimpleDropDown id={`toolSettings[${tool}].currency`} values={AVAILABLE_CURRENCIES}
                                  activeValue={settings.currency || "USD"} label="Currency"
                                  disabled={!canEditFields}
                                  onChange={(value) => store.dispatch(change('newEntity', `toolSettings[${tool}].currency`, value))} />
                </div>
              </div>
            </li>
            {/*Currency end*/}

            {/*showPricing*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].showPricing`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Show Pricing Visualizer" labelDisabled="Show Pricing Visualizer"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*showPricing end*/}

            {/*checkOut*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].checkOut`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="CheckOut" labelDisabled="CheckOut"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) || !settings.showPricing || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*checkOut end*/}

            {/*addLaborCustomer & addLaborInstaller*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER) ? (
                    <Field name={`toolSettings[${tool}].addLaborCustomer`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Add Labor Customer" labelDisabled="Add Labor Customer"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER) ? (
                    <Field name={`toolSettings[${tool}].addLaborInstaller`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Add Labor Installer" labelDisabled="Add Labor Installer"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*addLaborCustomer & addLaborInstaller end*/}

            {/*separateLaborInCart*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].separateLaborInCart`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Separate Labor in Cart" labelDisabled="Separate Labor in Cart"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) || !settings.showPricing || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*separateLaborInCart end*/}

            {/*enableSharing*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].enableSharing`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Enable Sharing" labelDisabled="Enable Sharing"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING) || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*enableSharing end*/}

            {/*wizardConsumers & wizardClients*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS) ? (
                    <Field name={`toolSettings[${tool}].wizardConsumers`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Wizard Consumers" labelDisabled="Wizard Consumers"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].wizardClients`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Wizard Dashboard" labelDisabled="Wizard Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*wizardConsumers & wizardClients end*/}

            {/*twoFA & twoFADashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) ? (
                    <Field name={`toolSettings[${tool}].twoFA`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="2 Factor Consumers" labelDisabled="2 Factor Consumers"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS)
                           || (!settings.leadCapture && !settings.clickLeadCapture && !settings.twoFA) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].twoFADashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="2 Factor Dashboard" labelDisabled="2 Factor Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD)
                           || (!settings.leadCaptureDashboard && !settings.clickLeadCaptureDashboard && !settings.twoFADashboard) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*twoFA & twoFADashboard end*/}

            {/*leadCapture & leadCaptureDashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? (
                    <Field name={`toolSettings[${tool}].leadCapture`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Locking Lead Capture Visualizer" labelDisabled="Locking Lead Capture Visualizer"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].leadCaptureDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Lead Capture Dashboard" labelDisabled="Lead Capture Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*leadCapture & leadCaptureDashboard end*/}

            {/*leadCapture Product Journey & leadCaptureDashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? (
                    <Field name={`toolSettings[${tool}].leadCaptureProduct`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Locking Lead Capture Visualizer Product Journey" labelDisabled="Locking Lead Capture Visualizer Product Journey"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].leadCaptureProductDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Locking Lead Capture Visualizer Product Journey Dashboard" labelDisabled="Locking Lead Capture Visualizer Product Journey Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*leadCapture & leadCaptureDashboard end*/}

            {/*clickLeadCapture & clickLeadCaptureDashboard & clickLeadCount*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  <div className="acc-block2">
                    {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? (
                      <div className="acc-block2__item">
                        <Field name={`toolSettings[${tool}].clickLeadCapture`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                               labelEnabled="Click to Lead Capture Visualizer" labelDisabled="Click to Lead Capture Visualizer"
                               disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) || allSettingsDisabled}/>
                      </div>
                    ) : null}
                    {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) && settings.clickLeadCapture ? (
                      <div className="acc-block2__item acc-small-field">
                        <Field name={`toolSettings[${tool}].clickLeadCount`} component={FormField} label="Click Count:" tool={tool}
                          disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) || allSettingsDisabled}/>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="acc-block">
                  <div className="acc-block2">
                    {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) ? (
                      <Field name={`toolSettings[${tool}].clickLeadCaptureDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                             labelEnabled="Click to Lead Capture Dashboard" labelDisabled="Click to Lead Capture Dashboard"
                             disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) || allSettingsDisabled}/>
                    ) : null}
                    {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) && settings.clickLeadCaptureDashboard ? (
                      <div className="acc-block2__item acc-small-field">
                        <Field name={`toolSettings[${tool}].clickLeadCount`} component={FormField} label="Click Count:" tool={tool}
                               disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) || allSettingsDisabled}/>
                      </div>
                    ) : null}
                  </div>
                </div>
              </li>
            ) : null}
            {/*clickLeadCapture & clickLeadCaptureDashboard & clickLeadCount end*/}

            {/*leadCaptureOnQuote*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].leadCaptureOnQuote`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Locking Lead Capture Consumers Quote" labelDisabled="Locking Lead Capture Consumers Quote"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*leadCaptureOnQuote end*/}

            {/*clickLeadCaptureOnQuote*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? (
              <li className={"acc-container__row" + (settings.clickLeadCaptureOnQuote ? " acc-container__row--united" : "")}>
                <div className="acc-block">
                  <div className="acc-block2">
                    <Field name={`toolSettings[${tool}].clickLeadCaptureOnQuote`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Click to Lead Capture On Quote" labelDisabled="Click to Lead Capture On Quote"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) || allSettingsDisabled}/>
                    {settings.clickLeadCaptureOnQuote ? (
                      <div className="acc-block2__item acc-small-field">
                        <Field name={`toolSettings[${tool}].clickLeadCountOnQuote`} component={FormField} label="Click Count:" tool={tool}
                               disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) || allSettingsDisabled}/>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="acc-block"/>
              </li>
            ) : null}
            {/*clickLeadCaptureOnQuote end*/}

            {/*leadCaptureShoppingCart & leadCaptureShoppingCartDashboard //TODO Needed permissions here*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].leadCaptureShoppingCart`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Lead Capture Shopping Cart" labelDisabled="Lead Capture Shopping Cart"
                       disabled={allSettingsDisabled} />
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].leadCaptureShoppingCartDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Lead Capture Shopping Cart (from Dashboard)" labelDisabled="Lead Capture Shopping Cart (from Dashboard)"
                       disabled={allSettingsDisabled} />
              </div>
            </li>
            {/*leadCaptureShoppingCart & leadCaptureShoppingCartDashboard end*/}

            {/*enableQuote & enableQuoteDashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) ? (
                    <Field name={`toolSettings[${tool}].enableQuote`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Enable Get Quote" labelDisabled="Enable Get Quote"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].enableQuoteDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Enable Get Quote (from Dashboard)" labelDisabled="Enable Get Quote (from Dashboard)"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*enableQuote & enableQuoteDashboard end*/}

            {/*enableQuote & enableQuoteDashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING) ? (
                    <Field name={`toolSettings[${tool}].enableScheduling`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Enable Scheduling" labelDisabled="Enable Scheduling"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].enableSchedulingDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Enable Scheduling (from Dashboard)" labelDisabled="Enable Scheduling (from Dashboard)"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*enableQuote & enableQuoteDashboard end*/}

            {/*enableCalendarForScheduling*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].enableCalendarForScheduling`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Enable Calendar for Scheduling" labelDisabled="Enable Calendar for Scheduling"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING) || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*enableCalendarForScheduling end*/}

            {/*visualizerOnly*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY) ? (
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].visualizerOnly`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                         labelEnabled="Visualizer Only" labelDisabled="Visualizer Only"
                         disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY) || allSettingsDisabled}/>
                </div>
              </li>
            ) : null}
            {/*visualizerOnly end*/}

            {/*showSmallBathroomDesignForClients & showSmallBathroomDesignFromDashboard*/}
            {tool == "bathroom" && (AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD)) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS) ? (
                    <Field name={`toolSettings[${tool}].showSmallDesignForClients`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Show Small Bathroom Design For Consumers" labelDisabled="Show Small Bathroom Design For Consumers"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].showSmallDesignFromDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Show Small Bathroom Design From Dashboard" labelDisabled="Show Small Bathroom Design From Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*showSmallBathroomDesignForClients & showSmallBathroomDesignFromDashboard end*/}

            {/*yesNoConsultationRequest*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION) ? (
              <li className={"acc-container__row" + (settings.yesNoConsultationRequest ? " acc-container__row--united" : "")}>
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].yesNoConsultationRequest`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                                                  labelEnabled="Yes/No Consultation Request" labelDisabled="Yes/No Consultation Request"
                                                  disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION) || allSettingsDisabled}/>
                </div>
                <div className="acc-block">
                  {settings.yesNoConsultationRequest ? (
                    <div className="acc-block2__item acc-small-field acc-full-field">
                      <Field name={`toolSettings[${tool}].noCallFabricatorId`} component={HiddenField}/>
                      <Field name={`toolSettings[${tool}].noCallFabricatorName`}
                             onClick={() => this.showNoCallFabricatorSelection(settings.noCallFabricatorId)}
                             disabled={allSettingsDisabled}
                             component={FormField} label="No Call Fabricator"/>
                    </div>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*yesNoConsultationRequest end*/}

            {/*enableFabricatorAutoCall & enableFabricatorAutoCallDashboard*/}
            {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD) || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD) ? (
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD) ? (
                    <Field name={`toolSettings[${tool}].enableFabricatorAutoCall`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Auto-Call Fabricator with New Lead" labelDisabled="Auto-Call Fabricator with New Lead"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD) || allSettingsDisabled}/>
                  ) : null}
                </div>
                <div className="acc-block">
                  {AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD) ? (
                    <Field name={`toolSettings[${tool}].enableFabricatorAutoCallDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                           labelEnabled="Auto-Call with New Lead From Dashboard" labelDisabled="Auto-Call with New Lead From Dashboard"
                           disabled={AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD) || allSettingsDisabled}/>
                  ) : null}
                </div>
              </li>
            ) : null}
            {/*enableFabricatorAutoCall & enableFabricatorAutoCallDashboard end*/}

            {/*enableCookiePopup*/}
            <li className="acc-container__row">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].enableCookiePopup`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Enable Cookie Popup" labelDisabled="Enable Cookie Popup"
                       disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*enableCookiePopup end*/}

            {/*showRecentlyViewedItems*/}
            <li className="acc-container__row">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showRecentlyViewedItems`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Show Recently Viewed Items" labelDisabled="Show Recently Viewed Items"
                       disabled={allSettingsDisabled} />
              </div>
            </li>
            {/*showRecentlyViewedItems end*/}
            {/*enableSqft TODO[Eugen] please add permissions here*/}
            <li className="acc-container__row">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].enableSqFt`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                      labelEnabled="Disable SQFT" labelDisabled="Disable SQFT"
                      disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*enableSqft end*/}

            {/*showTutorialVideo TODO[Eugen] please add permissions here*/}
            {tool == "kitchen" ?
              <li className="acc-container__row">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].showTutorialVideo`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                        labelEnabled="Show Tutorial Video" labelDisabled="Show Tutorial Video" disabled={allSettingsDisabled}/>
                </div>
              </li>
            : null }
            {/*showTutorialVideo end*/}

            {/*showVisualizerTutorial*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showVisualizerTutorial`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Show Visualizer Tutorial" labelDisabled="Show Visualizer Tutorial" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showVisualizerTutorialDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField} tool={tool}
                       labelEnabled="Show Visualizer Tutorial From Dashboard" labelDisabled="Show Visualizer Tutorial From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*showVisualizerTutorial end*/}

            {/*tax*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].sureTax`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Sure Tax" labelDisabled="Sure Tax" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].sureTaxDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Sure Tax From Dashboard" labelDisabled="Sure Tax From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*tax end*/}

            {/*shipping*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].useShipping`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Show Shipping" labelDisabled="Show Shipping" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].useShippingDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Show Shipping From Dashboard" labelDisabled="Show Shipping From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*shipping end*/}

            {/*showSqftTutorial*/}
            {tool == "kitchen" ?
              <li className="acc-container__row acc-container__row--united">
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].showSqftTutorial`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                        labelEnabled="Show SQFT Tutorial" labelDisabled="Show SQFT Tutorial" disabled={allSettingsDisabled}/>
                </div>
                <div className="acc-block">
                  <Field name={`toolSettings[${tool}].showSqftTutorialDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                        labelEnabled="Show SQFT Tutorial From Dashboard" labelDisabled="Show SQFT Tutorial From Dashboard" disabled={allSettingsDisabled}/>
                </div>
              </li>
            : null }
            {/*showSqftTutorial end*/}
            {/*showSlabMode*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showSlabMode`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                      labelEnabled="Show Slab Mode" labelDisabled="Show Slab Mode" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showSlabModeDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                      labelEnabled="Show Slab Mode From Dashboard" labelDisabled="Show Slab Mode From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*showSlabMode end*/}

            {/*showAveragePrice*/}
            <li className="acc-container__row">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showAveragePrice`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                      labelEnabled="Show Average Price" labelDisabled="Show Average Price" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*showAveragePrice end*/}

            {/*hide sku*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].hideSku`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Hide Sku On Products" labelDisabled="Hide Sku On Products" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].hideSkuDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Hide Sku On Products From Dashboard" labelDisabled="Hide Sku On Products From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*hide end*/}

            {/*Sale prices*/}
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showSalePrices`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Show Sale Prices" labelDisabled="Show Sale Prices" disabled={allSettingsDisabled}/>
              </div>
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].showSalePricesDashboard`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Show Sale Prices From Dashboard" labelDisabled="Show Sale Prices From Dashboard" disabled={allSettingsDisabled}/>
              </div>
            </li>
            {/*Sale prices end*/}

            {/*Cabinet Settings*/}
            {AR.isSiteAdmin() ?
              <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                  <div className="acc-checkbox">
                    <SimpleDropDown id={`toolSettings[${tool}].cabinetSettings`} values={['SQFT','LNFT', 'DoorsDrawers']}
                                    activeValue={settings.cabinetSettings} label={`Cabinet Settings`}
                                    disabled={!canEditFields}
                                    onChange={(value) => store.dispatch(change('newEntity', `toolSettings[${tool}].cabinetSettings`, value))}/>
                  </div>
                </div>
            </li> : null }
            {/*Cabinet Settings*/}

            {/*Cabinet Doors/Drawers and Boxes*/}
            {AR.isSiteAdmin() ? 
            <li className="acc-container__row acc-container__row--united">
              <div className="acc-block">
                <Field name={`toolSettings[${tool}].cabinetBoxes`} component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                       labelEnabled="Use Cabinet Boxes" labelDisabled="Use Cabinet Boxes" disabled={allSettingsDisabled}/>
              </div>
            </li> : null }
            {/*Cabinet Doors/Drawers and Boxes end*/}

            { tool == 'bathroom' && (IS_LIXIL_SERVERS || IS_QC_SERVERS) ? (
              <Fragment>
                {/*EnableASProductSync*/}
                <li className="acc-container__row">
                  <div className="acc-block">
                    <Field name="enableASProductSync" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Enable American Standard Product Sync" labelDisabled="Enable American Standard Product Sync"
                           disabled={allSettingsDisabled}/>
                  </div>
                </li>
                {/*EnableASProductSync end*/}

                {/*EnableASInventorySync*/}
                <li className="acc-container__row">
                  <div className="acc-block">
                    <Field name="enableASInventorySync" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Enable American Standard Inventory Sync" labelDisabled="Enable American Standard Inventory Sync"
                           disabled={allSettingsDisabled}/>
                  </div>
                </li>
                {/*EnableASInventorySync end*/}

                {/*EnbaleGProductionSync*/}
                <li className="acc-container__row">
                  <div className="acc-block">
                    <Field name="enableGProductSync" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Enable Grohe Product Sync" labelDisabled="Enable Grohe Product Sync"
                           disabled={allSettingsDisabled}/>
                  </div>
                </li>
                {/*EnbaleGProductionSync end*/}

                {/*EnableGInventorySync*/}
                <li className="acc-container__row">
                  <div className="acc-block">
                    <Field name="enableGInventorySync" component={FormCheckBoxField} onChecked={this.updateCheckBoxField}
                           labelEnabled="Enable Grohe Inventory Sync" labelDisabled="Enable Grohe Inventory Sync"
                           disabled={allSettingsDisabled}/>
                  </div>
                </li>
                {/*EnableGInventorySync end*/}
              </Fragment>
            ) : null}
          </ul>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {sectionsOpened, subscriptionsInfo, accountPageInfo} = store.accountState;
  return {
    accountPageInfo,
    sectionsOpened,
    subscriptionsInfo,
    AR: AccessRights.get(store),
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  showFabricatorsPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolSettings);

